import React, { useRef, useState } from 'react';
import { api } from '../scripts/api';
import CardComponent from '../components/CardComponent';

export default function VinScanPage() {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [vin, setVin] = useState('');
  const [rows, setRows] = useState([]);
  const [msg, setMsg] = useState('');
  const [matchedOn, setMatchedOn] = useState('');

  const scan = async (file) => {
    setBusy(true); setMsg(''); setRows([]); setMatchedOn('');
    try {
      const fd = new FormData();
      fd.append('file', file);
      const { data: ocrData } = await api.post('/ocr', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      const candidates = ocrData.candidates || [];
      if (!candidates.length) {
        setMsg('No text detected — try again or enter manually.');
        return;
      }
      // Search all candidates; backend returns best DB match
      const { data: matchData } = await api.post('/scan_match', { candidates });
      const results = matchData.results || [];
      if (results.length) {
        setVin(matchData.matched_by || candidates[0]);
        setMatchedOn(matchData.matched_by || '');
        setRows(results.map(r => r.record));
        setMsg('');
      } else {
        setVin(candidates[0]);
        setMsg(`No matching record found. Detected: ${candidates.slice(0, 4).join(', ')}`);
      }
    } catch (e) {
      console.error('OCR/search failed', e);
      setMsg('Scan failed — try again or enter manually.');
    } finally {
      setBusy(false);
    }
  };

  const manualSearch = async () => {
    if (!vin) return;
    setBusy(true); setMsg(''); setRows([]); setMatchedOn('');
    try {
      const { data: matchData } = await api.post('/scan_match', { candidates: [vin] });
      const results = matchData.results || [];
      if (results.length) {
        setMatchedOn(matchData.matched_by || vin);
        setRows(results.map(r => r.record));
        setMsg('');
      } else {
        // Fall back to the old search_by_vin for partial / last-8 searches
        const { data: res } = await api.get('/search_by_vin', { params: { v: vin } });
        const found = [...(res.inventory || []), ...(res.sold_inventory || [])];
        setRows(found);
        setMsg(found.length ? '' : 'No matching records found.');
      }
    } catch (e) {
      console.error('search failed', e);
      setMsg('Search failed.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="container">
      <div className="row" style={{ flexWrap: 'wrap', gap: 8 }}>
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          capture="environment"
          onChange={(e) => e.target.files?.[0] && scan(e.target.files[0])}
          style={{ display: 'none' }}
        />
        <button className="btn" onClick={() => inputRef.current?.click()}>
          Scan VIN / Label
        </button>
        <input
          className="input"
          value={vin}
          onChange={(e) => setVin(e.target.value)}
          placeholder="VIN, ROWO, or Stock/PO number"
          onKeyDown={(e) => e.key === 'Enter' && manualSearch()}
          style={{ flex: 1 }}
        />
        <button className="btn-outline" onClick={manualSearch}>
          Search
        </button>
      </div>

      {busy && <div className="muted" style={{ marginTop: 8 }}>Scanning…</div>}
      {msg  && <div className="muted" style={{ marginTop: 8 }}>{msg}</div>}
      {matchedOn && (
        <div style={{ marginTop: 6, fontSize: 12, color: '#22c55e', fontWeight: 700 }}>
          Matched on: {matchedOn}
        </div>
      )}

      <div className="space-y" style={{ marginTop: 12 }}>
        {rows.map((r) => (
          <CardComponent
            key={`vin-${r.id}-${r.rowo || ''}`}
            record={r}
            table="all_inventory"
          />
        ))}
      </div>
    </div>
  );
}
